var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        title: _vm.$t("message.selectFile"),
        description: _vm.multiple
          ? "Birden fazla dosya seçebilirsiniz"
          : "Bir dosya seçin",
        "class-name": "file-picker-modal",
      },
      on: { cancel: _vm.handleCancel, ok: _vm.handleConfirm },
    },
    [
      _c("div", { staticClass: "file-picker" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "a-breadcrumb",
              _vm._l(_vm.breadcrumbFolders, function (folder, index) {
                return _c("a-breadcrumb-item", { key: folder._id }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.navigateToFolder(folder._id)
                        },
                      },
                    },
                    [_vm._v(_vm._s(folder.name))]
                  ),
                ])
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "files-container" },
          _vm._l(_vm.currentFiles, function (file) {
            return _c("FileCard", {
              key: file._id,
              attrs: {
                file: file,
                readonly: true,
                selectionMode: true,
                selected: _vm.isFileSelected(file),
              },
              on: { doubleClick: _vm.handleDoubleClick },
              nativeOn: {
                click: function ($event) {
                  return _vm.toggleFileSelection(file)
                },
              },
            })
          }),
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }